<template>
    <div class="main">
        <my_menu></my_menu>

        <div class="content">


            <div class="add_button_div">
                <span class="tishi_txt">
                    <!-- <Icon type="md-alert" size="16" color="#0466dd" /> 字段ID需要为简历库的ID -->
                </span>
                <Button style="font-size:12px" type="primary" size="small" @click="add_show = true">
                    <Icon type="md-add" />添加新字段
                </Button>
            </div>
            <div class="table_box">
                <Spin fix size="large" v-if="table_loading"></Spin>
                <Table size="small" :height="windowHeight - 140" border :columns="columns" :data="table_data">
                </Table>
            </div>

        </div>

        <Modal v-model="add_show" title="添加字段" :footer-hide="true" width="500">
            <div>

                <div class="add_item">
                    <div class="add_item_field">字段名称:</div>
                    <Input v-model="add_field_data.name" placeholder="请输入字段名称" style="width: 300px" />
                </div>
                <div class="add_button">
                    <Button type="primary" @click="add_field">确认添加</Button>

                </div>


            </div>
        </Modal>
    </div>


</template>

<script>
import my_menu from '@/component/menu/menu.vue'
import { http } from "@/utils/http.js";

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            //系统列表
            table_data: [],
            columns: [],
            table_loading: false,
            page: 1,
            add_field_show: false,

            tabs_options: [],
            tabs_index: '',

            add_show: false,
            add_field_data: {
                field_id: "",
                name: "",
            }
        }
    },

    mounted() {
        this.get_field_list()
        this.window_change()
    },

    methods: {

        //确认添加
        add_field() {
            var that = this
            var obj = {
                name: this.add_field_data.name,
            }
            http("post", process.env.VUE_APP_HOST + "/roster_manage/field/add_field", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.get_field_list()
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.add_show = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },




        //获取字段列表
        get_field_list() {
            var that = this
            var obj = {
            }
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/roster_manage/field/list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.table_data = res.data.table_data
                        that.columns = res.data.columns

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.add_item_field {
    width: 100px;
    flex-shrink: 0;
}

.add_item {
    margin: 10px;
    display: flex;
    align-items: center;
}

.add_button {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.tishi_txt {
    font-size: 13px;
    color: #666;
    padding-left: 10px;
}

.add_button_div {
    padding-top: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    padding: 10px;
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>